import PropTypes from 'prop-types';
import '../style/emptyResult.css';

const EmptyResult = ({ imgSrc, isWebview, title, message }) =>
  isWebview ? (
    <div className="not-found not-found-webview">
      <img alt="Empty list" src={imgSrc} />
      <h2>{title}</h2>
      <span>{message}</span>
    </div>
  ) : (
    <div className="not-found">
      <img src={imgSrc} alt="Empty list" />
      <h3>{title}</h3>
      <div className="not-found-text">
        <div>{message}</div>
      </div>
    </div>
  );

EmptyResult.propTypes = {
  isWebview: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  imgSrc: PropTypes.string.isRequired,
};

EmptyResult.defaultProps = {
  message: '',
  title: '',
  isWebview: false,
};

export default EmptyResult;
